/**
 * CoursewaresList Messages
 *
 * This contains all the text for the CoursewaresList component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohort.coursewares';

export default defineMessages({
  internalServerErrorMessage: {
    id: `${scope}.errors.internalServerErrorMessage`,
    defaultMessage: 'An internal server error occurred. Please try again later.',
  },
  sbMediaGridDownloadFail: {
    id: `${scope}.errors.sbMediaGridDownloadFail`,
    defaultMessage: 'Failed to download the SB Media Grid. Please try again later.',
  },
  invalidSBMediaGridOption: {
    id: `${scope}.errors.invalidSBMediaGridOption`,
    defaultMessage: 'Invalid SB Media Grid option. Please try again later.',
  },
  listColumnHeaderTextTitle: {
    id: `${scope}.list.columns.headers.names.Title`,
    defaultMessage: 'Lesson Title',
  },
  updateDeployments: {
    id: `${scope}.actionsMenu.actions.updateDeployment`,
    defaultMessage: 'Update Deployment',
  },
  learnspaceUrl: {
    id: `${scope}.actionsMenu.actions.learnspaceUrl`,
    defaultMessage: 'Learnspace URL',
  },
  editActivity: {
    id: `${scope}.actionsMenu.actions.editActivity`,
    defaultMessage: 'Edit {activityType}',
  },
  showEnrollmentLinks: {
    id: `${scope}.actionsMenu.actions.showEnrollmentLinks`,
    defaultMessage: 'Enrollment URLs',
  },
  generateSBMediaGrid :{
    id : `${scope}.actionsMenu.action.generateSBMediaGrid`,
    defaultMessage : 'Generating SB Media Grid Download...',
  },
  downloadSitebuilderMediaGrid: {
    id: `${scope}.actionsMenu.actions.downloadSBMediaGrid`,
    defaultMessage: 'Download SB Media Grid',
  },
});
